import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { LoginModule } from './login/login.module';
import { ApplicationsModule } from './applications/applications.module';
import { DownloadsModule } from './downloads/downloads.module';
import { ReportingModule } from './reporting/reporting.module';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule.forRoot(),
        HttpModule,
        HttpClientModule,
        LoginModule,
        ApplicationsModule,
        DownloadsModule,
        ReportingModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
